import { View } from "react-native";
import React from "react";
import { ShopPagePhaseTwo } from "lib/sanity.types";
import { getSanityImage } from "lib/sanity";

const HeroSection = ({ shopPage }: { shopPage: ShopPagePhaseTwo }) => {
  return (
    <View>
      <img
        src={getSanityImage(shopPage.heroImage.asset._ref)}
        className="aspect-[21/9] md:aspect-auto"
      ></img>
    </View>
  );
};

export default HeroSection;
